import PropTypes from 'prop-types'
import OutboundDealsUrlParamsTableCellService from './outbound-deals-url-params-table-cell-service.js'

const propTypes = {
  deal                  : PropTypes.object,
  onClickRow            : PropTypes.func,
  outboundDealsColumns  : PropTypes.array,
  actionButtonText      : PropTypes.string
}

const defaultProps = {
  outboundDealsColumns : [],
  handleClickRow       : () => { }
}

/**
 * Component to display each Deal data in OutboundDealsUrlParamsTable
 * @param {Object} deal - Deal
 * @param {Function} onClickRow - function to navigate to Deal detail page when admin click on data row
 * @param {Array} outboundDealsColumns - Array of displayed outbound deals column section
 */
const OutboundDealsUrlParamsTableRow = ({
  deal,
  onClickRow,
  outboundDealsColumns
}) => {
  const dealsCellData = OutboundDealsUrlParamsTableCellService.generateDealCellData(deal)

  const handleClickRow = () => {
    onClickRow(deal.id)
  }

  return (
    <tr onClick={ handleClickRow }>
      {
        outboundDealsColumns.map((column) => {
          const cell = dealsCellData[column.name] || { content: '-', style: {} }
          const tdStyle = {
            ...(column.tdStyle || {}),
            ...(cell.style || {}),
          }

          return (
            <td
              key={ `outbound-deal-${deal.id}-${column.name}` }
              style={ tdStyle }
            >
              { cell.content }
            </td>
          )
        })
      }
    </tr>
  )
}

OutboundDealsUrlParamsTableRow.propTypes    = propTypes
OutboundDealsUrlParamsTableRow.defaultProps = defaultProps

export default OutboundDealsUrlParamsTableRow
